// extracted by mini-css-extract-plugin
export var root = "bb_yY";
export var wrapper = "bb_ry";
export var image = "bb_yZ d_w d_y d_W";
export var imageWithHeight = "bb_y0";
export var crop = "bb_y1";
export var round = "bb_y2";
export var fixedHeight = "bb_y3";